export default "__VITE_ASSET__Cf9$77FQ__"